import React from 'react';
import { useState, useEffect } from 'react';
import '../styles/Hero.css';
import { API_BASE_URL } from '../config/api';
import { Link, useNavigate } from 'react-router-dom';
import { productsByCategory , playSound} from '../utils/productUtils';
import { useProducts } from '../hooks/useProducts';
import { useCategoryNavigation } from '../hooks/useCategoryNavigation';
import { getCategoryPath } from '../utils/navigationUtils';


const Hero = () => {
const { products, categories } = useProducts();
// const { navigateToCategory } = useCategoryNavigation();


  
  const bePop = 'be-pop';
  const local = 'local';
  const com = 'com';
  const sport = 'sport';
  
  const bePopProducts = productsByCategory(products, bePop);
  const localProducts = productsByCategory(products, local);
  const comProducts   = productsByCategory(products, com);
  const sportProducts = productsByCategory(products, sport);

  const [currentIndex, setCurrentIndex] = useState({
    bePop: 0,
    local: 0,
    com: 0,
    sport : 0
  });



  const getImageUrl = (product) =>{
  
    const image = product?.medias.find(el => el.isCoverImage);

    return  image?.path
      ? `${API_BASE_URL}/${image.path}`
      : '';
  }

  
  useEffect(() => {
  if (
    !bePopProducts?.length &&
    !localProducts?.length &&
    !sportProducts?.length &&
    !comProducts?.length
  ) {
    return;
  }


  const interval = setInterval(() => {
    setCurrentIndex(prev => ({
      bePop: bePopProducts.length ? (prev.bePop + 1) % bePopProducts.length : 0,
      local: localProducts.length ? (prev.local + 1) % localProducts.length : 0,
      sport: sportProducts.length ? (prev.sport + 1) % sportProducts.length : 0,
      com: comProducts.length ? (prev.com + 1) % comProducts.length : 0,
    }));
  }, 3000);

  return () => clearInterval(interval);
}, [bePopProducts, localProducts, sportProducts, comProducts]);


  return (
    <div className="hero-container">
      <div id="container-cards-home">


        {/* Card BE-POP */}
        <div className='card-home-cnt card-left'>
          <div className='card-home card-blue'>
            <Link
              to={getCategoryPath('be-pop')}
              state={{ products, categories }}
              style={{ textDecoration: 'none', display: 'block', height: '100%', width: '100%' }}
              onClick={() => playSound()}
            >
              <div
                  key={currentIndex.bePop}
                  className="slot-slide"
                  style={{
                    backgroundImage: `url(${getImageUrl(bePopProducts[currentIndex.bePop])})`
                  }}
              />
            </Link>
          </div>
          <div className='label-card'>BE POP</div>
        </div>


        {/* Card LOCAL */}
        <div className='card-home-cnt card-center'>
          <div className="shop-btn-wrapper">
            <Link
              to="/shop"
              state={{ products, categories }}
              style={{ textDecoration: 'none' }}
            >
              <div className='shop-btn'>SHOP</div>
            </Link>
          </div>
          <div className='card-home card-violet'>
            <Link
              to={getCategoryPath('local')}
              state={{ products, categories }}
              style={{ textDecoration: 'none', display: 'block', height: '100%', width: '100%' }}
              onClick={() => playSound()}
            >
              <div
              key={currentIndex.local}
                className="slot-slide"
                style={{
                  backgroundImage: `url(${getImageUrl(localProducts[currentIndex.local])})`
                }}
              />
            </Link>
          </div>
          <div className='label-card'>LOCAL</div>
        </div>


        {/* Card SPORT */}
        <div className='card-home-cnt card-right'>
          <div className='card-home card-blue'>
            <Link
              to={getCategoryPath('sport')}
              state={{ products, categories }}
              style={{ textDecoration: 'none', display: 'block', height: '100%', width: '100%' }}
              onClick={() => playSound()}
            >
              <div
                key={currentIndex.sport}
                className="slot-slide"
                style={{
                  backgroundImage: `url(${getImageUrl(sportProducts[currentIndex.sport])})`
                }}
              />
            </Link>
          </div>
          <div className='label-card'>SPORT</div>
        </div>


      </div>
    </div>
  );
};
export default Hero;
